import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import NoDataImg from 'images/NoData/OwlWithEyeglass.png';

import styles from './NoData.module.scss';

const NoData = ({
  title = 'Ooops.. Looks like we can’t find and display this data',
  description = 'Try to choose other filters',
  className,
}) => (
  <div className={classNames(styles.root, className)} data-testid="noData-root">
    <img
      src={NoDataImg}
      className={styles.img}
      alt="no data image"
      data-testid="noData-img"
    />
    <div className={styles.textWrapper}>
      <Typography
        type="heading-sm"
        weight="bold"
        className={styles.title}
        data-testid="noData-title"
      >
        {title}
      </Typography>
      <Typography color="grey" data-testid="noData-description">
        {description}
      </Typography>
    </div>
  </div>
);

NoData.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default memo(NoData);
